import GoldDashboard from "./components/GoldDashboard.jsx";

export default function App() {
  return <GoldDashboard />;
}
